import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'

import Caixa from '../TermoVisita/ModulosCrefito/Caixa'
import HeaderVerde from '../TermoVisita/ModulosCrefito/HeaderVerde'
import QtdModulo from '../TermoVisita/ModulosCrefito/QtdModulo'
import TiposDespacho from './TiposDespacho'

const DespachoNovo = () => {
    const dadosDespacho = useSelector((state) => state.addForm.modulos.despachos)
    const [ficha, setFicha] = useState({
        processo: window.location.pathname.slice(14),
        user: localStorage.nome,
        fonte: localStorage.tipo,
        estado: localStorage.estado,
        responsavel: "",
        fiscalizado: "",
        destino: "",
        setorDestino: "",
        prazo: "",
        data: new Date().toLocaleDateString()
    })
    const [disabled, setDisabled] = useState(false)

    const updateField = (e) => {
        const { name, value } = e.target
        let update = { ...ficha }
        update[name] = value
        setFicha(update)
    }

    const enviar = () => {
        setDisabled(true)
        const url = `/api/despacho/despachoNovo`
        axios.post(url, { ficha, dadosDespacho })
            .then(res => {
                if (res.data.error) return alert(res.data.error)
                alert(res.data)
                window.location = `/documentosPaf/${ficha.processo}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    const styles = {
        principal: {
            display: "inline-grid", width: "35vw",
            textAlign: "left", color: "#484848", marginTop: "2vh"
        },
        input: {
            width: "35vw", backgroundColor: "#00000000", border: "1px solid #00000029",
            borderRadius: "5px", minHeight: "5px"
        }
    }
    return (
        <Caixa>
            <HeaderVerde texto="Despacho" />
            <div style={{ textAlign: "left" }}>
                <div style={{ ...styles.principal, marginRight: "10vw" }}>
                    <div>Usuário</div>
                    <div style={styles.input}>{ficha.user}</div>
                </div>
                <div style={styles.principal}>
                    <div>Responsável Técnico</div>
                    <input type="text" style={styles.input} name="responsavel" onChange={(e) => updateField(e)} />
                </div>
                <div style={{ ...styles.principal, marginRight: "10vw" }}>
                    <div>Fiscalizado</div>
                    <input type="text" style={styles.input} name="fiscalizado" onChange={(e) => updateField(e)} />
                </div>
                <div style={styles.principal}>
                    <div>Fonte</div>
                    <div style={styles.input}>{ficha.fonte === "fiscalAssessor" ? "FISCAL" : ficha.fonte.toUpperCase()}</div>
                </div>
                <div style={{ ...styles.principal, marginRight: "10vw" }}>
                    <div>Destino</div>
                    <select type="text" style={styles.input} name="destino" onChange={(e) => updateField(e)}>
                        {RenderOptions()}
                    </select>
                </div>
                {RenderPrazo()}
                <div style={{ marginTop: "5vh" }}>
                    <QtdModulo texto="Quantidade" modulo="despachos" />
                    <TiposDespacho modulo="despachos" />
                </div>
            </div>
            <button className='btn btn-success mt-2' onClick={e => enviar()} disabled={disabled}>Enviar</button>
        </Caixa>
    )

    function RenderPrazo() {
        let prazo = []
        if (ficha.destino === "Aguardando prazo") {
            prazo.push(
                <>
                    <div style={styles.principal}>
                        <div>Setor Destino</div>
                        <select type="text" style={styles.input}
                            name="setorDestino" onChange={(e) => updateField(e)}>
                            <option value=""></option>
                            <option value="Análise do Fiscal">Análise do Fiscal</option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Administrativo">Administrativo</option>
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                    <div style={styles.principal}>
                        <div>Fim do prazo</div>
                        <input type="date" style={styles.input}
                            name="prazo" onChange={(e) => updateField(e)} />
                    </div>
                </>
            )
        }
        return prazo
    }

    function RenderOptions() {
        let options = []
        if (ficha.fonte === "interno") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="Análise Fiscal">Análise Fiscal</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        if (ficha.fonte === "coordenacao" || ficha.fonte === "fiscalAssessor") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "coordenacao_pb") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "vice-presidencia") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "juridico") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "presidencia") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Presidência">Presidência</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "fiscal") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "defis") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        else if (ficha.fonte === "administrativo") {
            options.push(
                <>
                    <option value=""></option>
                    <option value="Revisita">Revisita</option>
                    <option value="Arquivo">Arquivo</option>
                    <option value="Presidência">Presidência</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                    <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                    <option value="AJUR Ações Ajuizadas">AJUR Ações Ajuizadas</option>
                    <option value="AJUR Procedimento no MP">AJUR Procedimento no MP</option>
                    <option value="Coordenação">Coordenação</option>
                    <option value="Aguardando prazo">Aguardando prazo</option>
                    <option value="Processo Ético">Processo Ético</option>
                    <option value="Denúncia">Denúncia</option>
                    <option value="Análise Fiscal">Análise Fiscal</option>
                    <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                    <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                    <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                </>
            )
        }
        return options
    }
}

export default DespachoNovo